module.exports = __webpack_public_path__ + "static/media/calendar.a6f9087a.svg";